import {
  GET_CATEGORY,
  GET_CATEGORY_FAIL,
  GET_CATEGORY_SUCCESS,
  GET_CATEGORY_DETAILS,
  GET_CATEGORY_DETAILS_FAIL,
  GET_CATEGORY_DETAILS_SUCCESS,
  ADD_NEW_CATEGORY,
  ADD_CATEGORY_SUCCESS,
  ADD_CATEGORY_FAIL,
  UPDATE_CATEGORY,
  UPDATE_CATEGORY_SUCCESS,
  UPDATE_CATEGORY_FAIL,
  DELETE_CATEGORY,
  DELETE_CATEGORY_SUCCESS,
  DELETE_CATEGORY_FAIL,  
  ACTIVATE_CATEGORY,
  ACTIVATE_CATEGORY_SUCCESS,
  ACTIVATE_CATEGORY_FAIL,
  DEACTIVATE_CATEGORY,
  DEACTIVATE_CATEGORY_SUCCESS,
  DEACTIVATE_CATEGORY_FAIL,
  RESET_CATEGORY_STATE,
} from "./actionTypes";

export const getCategory = ({length, sort, page,name}) => ({
  type: GET_CATEGORY,
  payload: {length, sort, page,name},
});

export const getCategorySuccess = category => ({
  type: GET_CATEGORY_SUCCESS,
  payload: category,
});

export const getCategoryFail = error => ({
  type: GET_CATEGORY_FAIL,
  payload: error,
});

export const getCategoryDetails = ({id}) => ({
  type: GET_CATEGORY_DETAILS,
  payload: {id},
});

export const getCategoryDetailsSuccess = category => ({
  type: GET_CATEGORY_DETAILS_SUCCESS,
  payload: category,
});

export const getCategoryDetailsFail = error => ({
  type: GET_CATEGORY_DETAILS_FAIL,
  payload: error,
});

//add 
export const addNewCategory = category => ({
  type: ADD_NEW_CATEGORY,
  payload: category,
});

export const addCategorySuccess = category => ({
  type: ADD_CATEGORY_SUCCESS,
  payload: category,
});

export const addCategoryFail = error => ({
  type: ADD_CATEGORY_FAIL,
  payload: error,
});

//update 
export const updateCategory =({id, category}) => ({
  type: UPDATE_CATEGORY,
  payload:{id, category},
});

export const updateCategorySuccess = category => ({
  type: UPDATE_CATEGORY_SUCCESS,
  payload: category,
});

export const updateCategoryFail = error => ({
  type: UPDATE_CATEGORY_FAIL,
  payload: error,
});

//delete 
export const deleteCategory =({id}) => ({
  type: DELETE_CATEGORY,
  payload:{id},
});

export const deleteCategorySuccess = category => ({
  type: DELETE_CATEGORY_SUCCESS,
  payload: category,
});

export const deleteCategoryFail = error => ({
  type: DELETE_CATEGORY_FAIL,
  payload: error,
});

//activate 
export const activateCategory =({id}) => ({
  type: ACTIVATE_CATEGORY,
  payload:{id},
});

export const activateCategorySuccess = category => ({
  type: ACTIVATE_CATEGORY_SUCCESS,
  payload: category,
});

export const activateCategoryFail = error => ({
  type: ACTIVATE_CATEGORY_FAIL,
  payload: error,
});

//deactivate 
export const deactivateCategory =({id}) => ({
  type: DEACTIVATE_CATEGORY,
  payload:{id},
});

export const deactivateCategorySuccess = category => ({
  type: DEACTIVATE_CATEGORY_SUCCESS,
  payload: category,
});

export const deactivateCategoryFail = error => ({
  type: DEACTIVATE_CATEGORY_FAIL,
  payload: error,
});

//reset
export const resetCategoryState = () => {
  return {
      type: RESET_CATEGORY_STATE,
  }
}


